export const REVISIONED_DOMAINS_MIGRATION_SQL = `
CREATE TABLE client_revisioned_entities (
  domain TEXT NOT NULL CHECK (domain IN ('agent', 'settings', 'graph')),
  id TEXT NOT NULL,
  rev INTEGER NOT NULL CHECK (rev >= 0),
  value_json TEXT NOT NULL,
  updated_at TEXT NOT NULL,
  PRIMARY KEY (domain, id)
) STRICT;

CREATE TABLE client_revisioned_commands (
  domain TEXT NOT NULL CHECK (domain IN ('agent', 'settings', 'graph')),
  idempotency_key TEXT NOT NULL,
  entity_id TEXT NOT NULL,
  result_json TEXT NOT NULL,
  created_at TEXT NOT NULL,
  PRIMARY KEY (domain, idempotency_key)
) STRICT;

CREATE INDEX idx_client_revisioned_entities_domain_rev
  ON client_revisioned_entities(domain, rev, id);
`;
//# sourceMappingURL=007_revisioned_domains.sql.js.map